<template>
  <div
    class="ce-onlyChangedDocsFilter"
    :class="{'disabled': disabled}">
    <checkbox
      :id="`key-${filterKey}`"
      :model-value="value"
      @update:model-value="toggle">
      {{ $t('productSheets.filter.onlyChangedDocs.label') }}
    </checkbox>

    <div class="ce-onlyChangedDocsFilter-legend">
      <div class="ce-onlyChangedDocsFilter-legend-version">
        <div class="ce-onlyChangedDocsFilter-legend-indicator" />
        {{ $t('productSheets.filter.onlyChangedDocs.legend.version') }}
      </div>
      <div class="ce-onlyChangedDocsFilter-legend-document">
        <div class="ce-onlyChangedDocsFilter-legend-indicator" />
        {{ $t('productSheets.filter.onlyChangedDocs.legend.document') }}
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from 'components/Checkbox.vue';
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    filterKey: {
      type: String,
      required: true
    },
    value: {
      type: Boolean || null,
      default: null
    },
  },
  components: { Checkbox },
  computed: {
    ...mapState('user', ['activeUser']),
    ...mapGetters(['urlFilters']),
    disabled() {
      return !this.activeUser || !this.activeUser.previousLogin;
    }
  },
  methods: {
    toggle(value) {
      const url = this.$cloneObject(this.urlFilters);

      this.$trackEvent('filter', 'toggle', { filterKey: this.filterKey, filterLabel: this.filterLabel, value });

      if (!value) {
        delete url[this.filterKey];
      } else {
        url[this.filterKey] = this.activeUser.previousLogin;
      }

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-onlyChangedDocsFilter {
    margin-bottom: @space-3;
    padding: @space-2 @space-3;
    background: @ce-filter-background-color;
    border-radius: @border-radius;
    color: @ce-filter-color;
    .noselect();
    .ms(-1);

    &.disabled {
      display: none;
    }

    .ce-onlyChangedDocsFilter-legend {
      margin-top: @space-3;
      padding: 0 5px;

      > div {
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: @space-1;
        }

        .ce-onlyChangedDocsFilter-legend-indicator {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: @space-2;
        }

        &.ce-onlyChangedDocsFilter-legend-document {
          .ce-onlyChangedDocsFilter-legend-indicator {
            background: @color-secondary;
          }
        }

        &.ce-onlyChangedDocsFilter-legend-version {
          .ce-onlyChangedDocsFilter-legend-indicator {
            background: @color-light;
          }
        }
      }
    }
  }
</style>
